import { Constants } from "../math/constants";
import { MenuActionType } from "../menu/menu-action-type";
import { IGameConfig } from "../types/game-config-type";

export const GameConfig: IGameConfig = {
  screenId: 'screen',
  gameAreaId: 'gameArea',
  chatId: 'chat',
  gameSize: { x: 1664, y: 873 }, // width and height of the table image
  soundOn: true,
  timeoutToHideStickAfterShot: 500,
  timeoutToHideBallAfterPocket: 100,
  loadingScreenTimeout: 1000,
  loadingScreenImagePosition: { x: 450, y: 112.5 },
  hitMarkerPosition: { x: 1510, y: 100 },
  hitMarkerDiameter: 64,
  hitPowerIndicatorPosition: { x: 1542, y: 250 },
  timeoutToLoadSubMenu: 100,
  
  pottedBallsWidth: 80, // width of the potted balls bar
  pottedBallsSpawn: { x: 63, y: 145 }, // where the balls fall into the potted balls bar
  pottedBallsLeftEdge: 30,
  pottedBallsBottomEdge: 845,

  cueBallPosition: { x: 413, y: Constants.Y_CENTER }, // for all games

  // for US and UK 8 ball pool
  yellowBallsPositions: [
    { x: Constants.X_CENTER - Constants.BALL_SIZE, y: Constants.Y_CENTER + ((Constants.BALL_SIZE / 2)) },
    { x: Constants.X_CENTER, y: Constants.Y_CENTER - (Constants.BALL_SIZE) },
    { x: Constants.X_CENTER + (Constants.BALL_SIZE), y: Constants.Y_CENTER + ((Constants.BALL_SIZE / 2)) },
    { x: Constants.X_CENTER + (Constants.BALL_SIZE), y: Constants.Y_CENTER + (Constants.BALL_SIZE + (Constants.BALL_SIZE / 2)) },
    { x: Constants.X_CENTER + (Constants.BALL_SIZE * 2), y: Constants.Y_CENTER + (Constants.BALL_SIZE * 2) },
    { x: Constants.X_CENTER + (Constants.BALL_SIZE * 2), y: Constants.Y_CENTER + (Constants.BALL_SIZE) },
    { x: Constants.X_CENTER + (Constants.BALL_SIZE * 2), y: Constants.Y_CENTER - (Constants.BALL_SIZE) },
  ],

  // for US and UK 8 ball pool
  redBallsPositions: [
    { x: Constants.X_CENTER - (Constants.BALL_SIZE * 2) , y: Constants.Y_CENTER },
    { x: Constants.X_CENTER - Constants.BALL_SIZE, y: Constants.Y_CENTER - (Constants.BALL_SIZE - (Constants.BALL_SIZE / 2)) },
    { x: Constants.X_CENTER, y: Constants.Y_CENTER + (Constants.BALL_SIZE) }, 
    { x: Constants.X_CENTER + (Constants.BALL_SIZE), y: Constants.Y_CENTER - (Constants.BALL_SIZE * 2 - (Constants.BALL_SIZE / 2)) },
    { x: Constants.X_CENTER + (Constants.BALL_SIZE), y: Constants.Y_CENTER - (Constants.BALL_SIZE - (Constants.BALL_SIZE / 2)) },
    { x: Constants.X_CENTER + (Constants.BALL_SIZE * 2), y: Constants.Y_CENTER },
    { x: Constants.X_CENTER + (Constants.BALL_SIZE * 2), y: Constants.Y_CENTER - (Constants.BALL_SIZE * 2) },
  ],

  // for US and UK 8 ball pool
  eightBallPosition: { x: Constants.X_CENTER, y: Constants.Y_CENTER },

  nineBallsPositions: [
    { x: Constants.X_CENTER - (Constants.BALL_SIZE * 2), y: Constants.Y_CENTER },
    
    { x: Constants.X_CENTER - (Constants.BALL_SIZE), y: Constants.Y_CENTER + ((Constants.BALL_SIZE / 2))},
    { x: Constants.X_CENTER - (Constants.BALL_SIZE), y: Constants.Y_CENTER - (Constants.BALL_SIZE - (Constants.BALL_SIZE / 2)) },
    
    { x: Constants.X_CENTER, y: Constants.Y_CENTER - (Constants.BALL_SIZE) },
    { x: Constants.X_CENTER, y: Constants.Y_CENTER + (Constants.BALL_SIZE) },
    
    { x: Constants.X_CENTER + (Constants.BALL_SIZE), y: Constants.Y_CENTER - (Constants.BALL_SIZE - (Constants.BALL_SIZE / 2)) },
    { x: Constants.X_CENTER + (Constants.BALL_SIZE), y: Constants.Y_CENTER + ((Constants.BALL_SIZE / 2)) }, 
    
    { x: Constants.X_CENTER + (Constants.BALL_SIZE * 2), y: Constants.Y_CENTER },
  ],
  
  nineBallPosition: { x: Constants.X_CENTER, y: Constants.Y_CENTER },

  snookerRedBallsPositions: [ 
    { x: Constants.X_CENTER + (Constants.BALL_SIZE * 2), y: Constants.Y_CENTER - (Constants.BALL_SIZE * 2) },
    { x: Constants.X_CENTER + (Constants.BALL_SIZE * 2), y: Constants.Y_CENTER - (Constants.BALL_SIZE) },
    { x: Constants.X_CENTER + (Constants.BALL_SIZE * 2), y: Constants.Y_CENTER },
    { x: Constants.X_CENTER + (Constants.BALL_SIZE * 2), y: Constants.Y_CENTER + (Constants.BALL_SIZE) },
    { x: Constants.X_CENTER + (Constants.BALL_SIZE * 2), y: Constants.Y_CENTER + (Constants.BALL_SIZE * 2) },
   
    { x: Constants.X_CENTER + (Constants.BALL_SIZE), y: Constants.Y_CENTER - (Constants.BALL_SIZE * 2 - (Constants.BALL_SIZE / 2)) },
    { x: Constants.X_CENTER + (Constants.BALL_SIZE), y: Constants.Y_CENTER - (Constants.BALL_SIZE - (Constants.BALL_SIZE / 2)) },
    { x: Constants.X_CENTER + (Constants.BALL_SIZE), y: Constants.Y_CENTER + ((Constants.BALL_SIZE / 2)) },
    { x: Constants.X_CENTER + (Constants.BALL_SIZE), y: Constants.Y_CENTER + (Constants.BALL_SIZE + (Constants.BALL_SIZE / 2)) },
   
    { x: Constants.X_CENTER, y: Constants.Y_CENTER - (Constants.BALL_SIZE) },
    { x: Constants.X_CENTER, y: Constants.Y_CENTER }, // centre ball
    { x: Constants.X_CENTER, y: Constants.Y_CENTER + (Constants.BALL_SIZE) }, 
   
    { x: Constants.X_CENTER - Constants.BALL_SIZE, y: Constants.Y_CENTER - (Constants.BALL_SIZE - (Constants.BALL_SIZE / 2)) },
    { x: Constants.X_CENTER - Constants.BALL_SIZE, y: Constants.Y_CENTER + ((Constants.BALL_SIZE / 2)) },

    { x: Constants.X_CENTER - (Constants.BALL_SIZE * 2) , y: Constants.Y_CENTER },
  ],

   snookerSixRedBallsPositions: [   
    { x: Constants.X_CENTER, y: Constants.Y_CENTER - (Constants.BALL_SIZE) },
    { x: Constants.X_CENTER, y: Constants.Y_CENTER }, // centre ball
    { x: Constants.X_CENTER, y: Constants.Y_CENTER + (Constants.BALL_SIZE) }, 
   
    { x: Constants.X_CENTER - Constants.BALL_SIZE, y: Constants.Y_CENTER - (Constants.BALL_SIZE - (Constants.BALL_SIZE / 2)) },
    { x: Constants.X_CENTER - Constants.BALL_SIZE, y: Constants.Y_CENTER + ((Constants.BALL_SIZE / 2)) },

    { x: Constants.X_CENTER - (Constants.BALL_SIZE * 2) , y: Constants.Y_CENTER }, 
  ],

  /*
   * Snooker coloured ball positions.
   */ 
  blackBallPosition: { x: 1400, y: Constants.Y_CENTER },
  pinkBallPosition: { x: Constants.X_CENTER - (Constants.BALL_SIZE * 3), y: Constants.Y_CENTER }, // the x position is calculated
  blueBallPosition: { x: 880, y: Constants.Y_CENTER },
  greenBallPosition: { x: 475, y: 283 },
  brownBallPosition: { x: 475, y: Constants.Y_CENTER },
  yellowBallPosition: { x: 475, y: 583 },

  sprites: {
    basePath: 'assets/sprites/',
    paths: {
      menuBackground: 'pool-splash.svg',
      menuBackground2: 'snooker-splash.svg',
      tableBlue: 'table-blue.png',
      tableGreen: 'table-green.png',
      tableRed: 'table-red.png',
      table: 'table-green2.png',
      stick: 'stick.png',
      ball9: 'ballSprite9.png',
      ball10: 'ballSprite10.png',
      ball11: 'ballSprite11.png',
      ball12: 'ballSprite12.png',
      ball13: 'ballSprite13.png',
      ball14: 'ballSprite14.png',
      ball15: 'ballSprite15.png',
      solidBalls: 'solidsSprite.png',
      labelsSprite: 'spotSprite.png',
      hitMarker: 'ball.png',
      logo: 'logo.png',
    },
  },

  cueSticks: {
    basePath: 'assets/cue-sticks/',
    paths: {
      raven: '1.png',
      blueHope: '2.png',
      testTube: '3.png',
      posh: '4.png',
      bearPaw: '5.png',
      royalBlue: '6.png',
      crocodile: '7.png',
      theDeputy: '8.png',
    },
  },

  sounds: {
    basePath: 'assets/sounds/',
    paths: {
      BALL_BALL: 'ballball_quiet.wav',
      CUE_HIT: 'cueball.wav',
      BALL_IN_POCKET: 'ballpocket.wav',
      BALL_RAIL: 'cueball.wav',
      CUE_BALL_BALL: 'ballball_loud.wav',
      TIMER_BEEP: 'timer_beep.wav',
      INVITATION_DIALOG: 'invitation_dialog.wav',
      PASS_BACK: 'boing.wav',
      ERROR_BEEP: 'error_beep.wav'
    },
  },

  physics: {
    friction: 0.018, // table friction
    collisionLoss: 0.02, // collision loss between two balls
    rotationFriction: 0.03, // spin friction
    counterRotationFriction: 0.036, // counter spin friction
    rotationToVelocity: 0.2, // ball spin velocity (when there is more spin there is more velocity)
    powerToRotationRatio: 0.25 // cue stick power applied to the cue ball
  },

  table: {
    cushionWidth: 67,
    pocketRadius: 64, // was 53 (also 85 for testing)
    pocketsPositions: [
      { x: 135, y: 60 }, // top left
      { x: 870, y: 55 }, // top middle
      { x: 1610, y: 60 }, // top right
      { x: 135, y: 810 }, // bottom left
      { x: 870, y: 820 }, // bottom middle
      { x: 1610, y: 810 }, // bottom right
    ],
  },

  ball: {
    diameter: 44, // was 34
    origin: { x: 25, y: 25 },
    minVelocityLength: 0.05,
    maxExpectedVelocity: 120,
    maxExpectedCollisionForce: 70,
  },

  stick: {
    origin: { x: 970, y: 11 },
    shotOrigin: { x: 950, y: 11 },
    powerToAddPerFrame: 1,
    movementPerFrame: 3,
    maxPower: 50,
  },

  input: {
    mouseSelectButton: 0,
    mouseShootButton: 0,
    mousePlaceBallButton: 0,
    mouseToggleHitlineButton: 2,
    toggleMenuKey: 27,
    upHitKey: 87,
    downHitKey: 83,
    leftHitKey: 65,
    rightHitKey: 68,
    increaseShotPowerKey: 87,
    decreaseShotPowerKey: 83,
  },

  settings: {
    enableSounds: true,
    enableChatMessages: true,
    acceptChallengesFrom: 'ACCEPT_EVERYONE', // 'ACCEPT_EVERYONE' or 'ACCEPT_FRIENDS_ONLY' 
    blockAllGameChallenges: false,
    blockWagerGameChallenges: false,
    hitPositionSize: 'LARGE_BALL', // 'SMALL_BALL' or 'LARGE_BALL'
    defaultPracticeGame: 'POOL8', // game kind value
  },

 /*
  * THIS 'mainMenu' IS THE LEGACY MAIN MENU FROM THE OPEN SOURCE PROJECT.
  * THIS CODE IS RELATED TO THE MENU PACKAGE OF THE APPLICATION.
  */
  mainMenu: {
    labels: [
      {
        text: 'Send your friends to play.booza.com',
        position: { x: 710, y: 550 },
        font: '30px chunkfive',
        color: 'black',
        alignment: 'left',
      },
    ],

    buttons: [
      {
        action: MenuActionType.GoToPreviousMenu,
        position: { x: 700, y: 300 },
        sprite: 'logo', 
        spriteOnHover: 'logo', 
      }
    ],

    subMenus: [
      {
        labels: [],
        buttons: [],
        subMenus: [],
      },
    ],
  },

  cursor: {
    default: 'default',
    button: 'pointer',
  },
};
